import {
  ContextMenuItem,
  ContextMenuRole,
  WorksheetInstance,
} from "jspreadsheet-ce";

export const contextMenu = (
  instance: WorksheetInstance,
  colIndex: string | number | null,
  rowIndex: string | number | null,
  event: PointerEvent,
  items: ContextMenuItem[],
  role: ContextMenuRole,
  x: string | number | null,
  y: string | number | null,
) => {
  return false;
};
